export default "__VITE_ASSET__9df352e5__"